/* ===== NINE™ — shared interactions ===== */
(function () {
  "use strict";

  const nav = document.querySelector("header.nav");
  if (nav) {
    const onScroll = () => nav.classList.toggle("scrolled", window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  const burger = document.querySelector(".burger");
  const links = document.querySelector(".nav-links");
  if (burger && links) {
    const setMenuOpen = (open) => {
      links.classList.toggle("mobile-open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      burger.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    };
    burger.addEventListener("click", () => setMenuOpen(!links.classList.contains("mobile-open")));
    links.querySelectorAll("a").forEach((a) =>
      a.addEventListener("click", () => setMenuOpen(false))
    );
  }

  document.querySelectorAll(".faq-q").forEach((btn) => {
    btn.addEventListener("click", () => {
      const item = btn.closest(".faq-item");
      const isOpen = item.classList.contains("open");
      document.querySelectorAll(".faq-item.open").forEach((o) => o.classList.remove("open"));
      if (!isOpen) item.classList.add("open");
    });
  });

  let toastTimer;
  window.showToast = function (msg) {
    let t = document.querySelector(".toast");
    if (!t) {
      t = document.createElement("div");
      t.className = "toast";
      t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
      document.body.appendChild(t);
    }
    t.querySelector("span").textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("show"), 2600);
  };

  window.cartCount = 0;
  window.syncCartCount = function (count) {
    if (typeof count === "number") window.cartCount = count;
    document.querySelectorAll("[data-cart-count]").forEach((el) => (el.textContent = window.cartCount));
  };
  window.bumpCart = function (n) {
    window.syncCartCount(window.cartCount + n);
  };

  fetch(`${window.Shopify?.routes?.root || window.routes?.cart_url?.replace("/cart", "/") || "/"}cart.js`)
    .then((r) => r.json())
    .then((cart) => window.syncCartCount(cart.item_count))
    .catch(() => {});

  const overlay = document.querySelector(".modal-overlay");
  const isOfferPage =
    document.body.classList.contains("template-index") ||
    document.body.classList.contains("template-product");
  if (overlay && isOfferPage) {
    let shown = sessionStorage.getItem("nd-offer-shown") === "1";
    const open = () => {
      if (shown) return;
      overlay.classList.add("show");
      shown = true;
      sessionStorage.setItem("nd-offer-shown", "1");
    };
    const timer = setTimeout(open, 5000);
    const close = () => overlay.classList.remove("show");
    overlay.querySelector(".modal-close")?.addEventListener("click", () => { close(); clearTimeout(timer); });
    overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });

    const form = overlay.querySelector("form");
    form?.addEventListener("submit", () => {
      setTimeout(() => {
        overlay.querySelector(".modal-default").style.display = "none";
        overlay.querySelector(".modal-success").style.display = "block";
      }, 400);
    });

    document.querySelectorAll("[data-open-offer]").forEach((b) =>
      b.addEventListener("click", (e) => { e.preventDefault(); shown = false; open(); })
    );
  }

  document.querySelectorAll("form[data-email-inline]").forEach((f) => {
    f.addEventListener("submit", (e) => {
      setTimeout(() => {
        f.innerHTML = '<p style="margin:0;font-weight:600;color:#12260f">✓ You\'re in — code <b>NINE10</b> is on its way.</p>';
      }, 400);
    });
  });
})();
